<template>
<!-- the v-app will contains the classes for the layouts -->
  <v-app class="Appx">
    <MainHeader v-if="!hideNav.includes($route.name)"/>
    <!-- <MainStoryHeader v-if="mainHeaderNav.includes($route.name)" /> -->
    <!-- <StoryEditHeader  /> -->
    <MobileTopBar/>
    <div class="main-wrapper">
      <SideBar v-if="!hideSideBar.includes($route.name)"/>
      <router-view class="content"></router-view>
      <MobileBottomBar/>
    </div>
    <div v-if="$store.state.modelOpened" class="screen__clone" @click="$store.state.modelOpened = false"></div>
  </v-app>
</template>

<script>
import MainHeader from "./components/global/MainHeader";
import StoryEditHeader from './components/v2/story-edit-view/header.vue'
import MainStoryHeader from './components/v2/main-story-view/header.vue'
import MobileBottomBar from "./components/global/sections/MobileBottomBar";
import MobileTopBar from "./components/global/sections/MobileTopBar.vue";
import SideBar from "./components/profile/sidebar.vue";

export default {
  data() {
    return {
      drawer: false,
      isList: false,
      appTtile: "iBegoo",
      hideNav: [
        "globalLogicEditView",
        "addGlobalLogic",
        "",
        "welcome",
        "signin",
        "signup",
        "forgot",
      ],
      hideSideBar: [
        "",
        "welcome",
        "signin",
        "signup",
        "forgot",
      ]
    };
  },
  components: {
    MainHeader,
    SideBar,
    MobileBottomBar,
    MainStoryHeader,
    StoryEditHeader,
    MobileTopBar
  },
  computed: {
    username() {
      let email = this.$store.state.user.email;
      // computed the user name format
      return "Welcome " + email.match(/([a-zA-Z0-9-_.]+)/gi)[0];
    },
    appTitle() {
      return this.$store.state.appTitle;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    // toolbarItems1 () {
    //   if (this.isAuthenticated) {
    //     return [
    //       // { title: 'Create Story', path: '/storylistCreate', icon: 'add' },
    //       { title: 'Story List', path: '/storylist', icon: 'book' },
    //       { title: 'Asset', path: '/assets', icon: 'build' }
    //     ]
    //   } else {
    //     return [
    //       { title: 'Sign Up', path: '/signup', icon: 'face' },
    //       { title: 'Sign In', path: '/signin', icon: 'lock_open' }
    //     ]
    //   }
    // },
    // ExpansionItems () {
    //   if (this.isAuthenticated) {
    //     return [
    //       {
    //         drawer: true,
    //         action: 'build',
    //         title: 'Asset',
    //         active: true,
    //         items: [
    //           { title: 'Set Design', path: 'assets' },
    //           { title: 'Prop' },
    //           { title: 'Character Action' },
    //           { title: 'Character Model' },
    //           { title: 'Scene Name' },
    //           { title: 'Voice' },
    //           { title: 'Prop Action' },
    //           { title: 'Sound' }
    //         ]
    //       }
    //     ]
    //   } else {
    //     return [
    //       { title: 'Sign Up', path: '/signup', icon: 'face' },
    //       { title: 'Sign In', path: '/signin', icon: 'lock_open' }
    //     ]
    //   }
    // },
    // toolbarItems2 () {
    //   if (this.isAuthenticated) {
    //     return [
    //       { title: 'Demo', path: '/welcome', icon: 'label' },
    //       { title: 'Edit Profile', path: '/editprofile', icon: 'person_outline' },
    //       { title: 'Contact', path: '/contact', icon: 'email' },
    //       { title: 'FAQ', path: '/faq', icon: 'help_outline' }
    //       // { title: 'Edit Profile', path: '/editprofile' },
    //       // { title: 'Stories', path: '/storylist' },
    //       // { title: 'Assets', path: '/assets' }
    //     ]
    //   } else {
    //     return [
    //       { title: 'Sign Up', path: '/signup', icon: 'face' },
    //       { title: 'Sign In', path: '/signin', icon: 'lock_open' }
    //     ]
    //   }
    // },
    // menu contents list, please make sure you define the route in router's folder
    menuItems() {
      if (this.isAuthenticated) {
        return [
          { title: "Profile", path: "/profile", icon: "person_outline" },
          { title: "Stories", path: "/storylist", icon: "book" },
          { title: "Assets", path: "/assets", icon: "build" },
          { title: "API Calls", path: "/userclass", icon: "group" },
          { title: "Main Story", path: "/mainStoryView", icon: "auto_stories" },
          // { title: 'temp', path: '/temp', icon: 'face' }
        ];
      } else {
        return [
          { title: "Sign Up", path: "/signup", icon: "face" },
          { title: "Sign In", path: "/signin", icon: "lock_open" },
        ];
      }
    },
  },
  methods: {
    userSignOut() {
      this.$store.dispatch("userSignOut");
    },
  },
  created() {
    this.$store.dispatch("getUserDevice");
  },
    
};
</script>

<style scoped lang="scss">
.vv-logo {
  display: flex;
  align-items: center;
  margin: 0;
  cursor: pointer;

  img {
    max-width: 120px;
    height: 30px;
    margin-right: 10px;
    margin-top: 5px;
  }

  svg {
    padding-right: 1000px;
  }
}

.Appx {
  position: relative;
  display: flex;
}
.screen__clone {
  position : absolute;
  top : 0;
  bottom: 0;
  left : 0;
  right : 0;
  background-color : transparent;
  z-index: 0;
}

.main-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 64px);
}

// .content {
  // margin-top: 36px;
  // margin-bottom: 100px;
// }
// .vv-toolbar {
//   z-index: 25;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue